export default {"src":"/_next/static/media/since_1999_icon.03753d79.svg","height":70,"width":181,"blurWidth":0,"blurHeight":0};